module.exports = __webpack_public_path__ + "img/media-folder-minus.50459999.svg";